import React from 'react'
import { useRadioGroupState } from '@react-stately/radio'
import { useRadioGroup } from '@react-aria/radio'
import { PaymentPlan } from 'api/clients/PaymentPlanClient'
import styles from './PlanSelect.module.scss'
import { BillingOption } from './BillingOption'

interface PlanOptionsProps {
  plan: PaymentPlan
  defaultValue?: 'monthly' | 'annual'
  onChange?: (value: 'monthly' | 'annual') => void
  isInTrial?: boolean
}

export function PlanOptions({ plan, defaultValue = 'annual', onChange, isInTrial = true }: PlanOptionsProps) {
  const state = useRadioGroupState({
    defaultValue,
    onChange: (value) => {
      if (onChange) {
        onChange(value as 'monthly' | 'annual')
      }
    },
  })

  const { radioGroupProps } = useRadioGroup(
    {
      'aria-label': 'Billing options',
    },
    state,
  )

  return (
    <div {...radioGroupProps} className={styles.planSelect}>
      <BillingOption
        value="annual"
        label="Annual Pro Plan"
        price={plan.price.year}
        discount={isInTrial}
        state={state}
      />
      <BillingOption value="monthly" label="Monthly Pro Plan" price={plan.price.month} state={state} />
    </div>
  )
}
